import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { GN } from '../../../gn';
import { DIC } from '../../dic';
/**
 * Generated class for the RepmapPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

declare var google;

@Component({
  selector: 'page-repmap',
  templateUrl: 'repmap.html',
})
export class RepmapPage {
  @ViewChild('mapFull') mapElement: ElementRef;
  dt: any
  lat: any
  lon: any
  speed: any
  code: any
  reg: any
  location: any
  Map: any
  garminss = 'false'
  driverscore = 'false'
  nospeed = 'false'
  scoredesc = ''
  scoredriverfullname = ''
  addinfo = ''

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {
    console.log(navParams.get('nospeed'), navParams.get('datetime'))
    this.dt = navParams.get('datetime')
    this.lat = navParams.get('latitude')
    this.lon = navParams.get('longitude')
    this.speed = parseInt(navParams.get('speed'))
    this.code = navParams.get('code')
    this.reg = navParams.get('reg')
    this.location = navParams.get('location') + '' != 'undefined' ? navParams.get('location') : ''
    this.garminss = navParams.get('garminss') + '' != 'undefined' ? 'true' : 'false'
    this.driverscore = navParams.get('driverscore') + '' != 'undefined' ? 'true' : 'false'
    this.nospeed = navParams.get('nospeed') + '' != 'undefined' ? 'true' : 'false'
    this.scoredesc = navParams.get('scoredesc') + '' != 'undefined' ? navParams.get('scoredesc') : ''
    this.scoredriverfullname = navParams.get('scoredriverfullname') + '' != 'undefined' ? navParams.get('scoredriverfullname') : ''
    this.addinfo = navParams.get('addinfo') + '' != 'undefined' ? navParams.get('addinfo') : ''
  }

  ionViewDidLoad() {
    this.initMap()
  }


  numberWithCommas = (x) => {
    if (x != null)
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    else
      return x;
  }

  sec2str3(_sec) {
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"] + ' ' + s + this.dic.l["sec"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }

  initMap() {
    var mapOptions = {
      zoom: 15,
      maxZoom: 20,
      minZoom: 6,
    }
    this.Map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.gn._Post('/api/gn/insertgoogleuse', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), path: this.gn.crypt('rep map') }, function () {
    })

    var myLatLng = { lat: parseFloat(this.lat), lng: parseFloat(this.lon) };

    //
    var markerIcon = {
      url: 'assets/imgs/newpin-red.png',
      scaledSize: new google.maps.Size(38, 43),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(13, 43),
      labelOrigin: new google.maps.Point(13, 13)
    };

    /*done*/var marker = new google.maps.Marker({
      position: myLatLng,
      map: this.Map,
      icon: markerIcon,
      label: {
        //text: lbl,
        color: "#000",
        fontSize: "14px",
        fontWeight: "bold",
      }
    });
    //
    this.Map.setCenter(myLatLng)

    var _content = ``
    if (this.garminss == 'false' && this.driverscore == 'false') {
      _content += `<div class="mapwindow-text">` + this.dic.l["registration"] + `: <b>` + this.code + ' - ' + this.reg + `</b></div>`
    }
    _content += `
        <div class="mapwindow-text">`+ this.dic.l["Date"] + `: <b>` + moment(this.dt).format(this.gn.user.DFormat) + `</b></div>
        <div class="mapwindow-text">`+ this.dic.l["Time"] + `: <b>` + moment(this.dt).format(this.gn.user.TFormat) + `</b></div>
    `
    if (this.garminss == 'false' && this.driverscore == 'false' && this.nospeed == 'false') {
      _content += `<div class="mapwindow-text">` + this.dic.l["Speed"] + `: <b>` + this.speed + `</b> Km/h</div>`
    }

    if (this.driverscore == 'true' && this.scoredesc == this.dic.l["highSpeed"]) {
      _content += `<div class="mapwindow-text">` + this.dic.l["Speed"] + `: <b>` + this.addinfo + `</b> Km/h</div>`
    }
    if (this.driverscore == 'true' && this.scoredesc == this.dic.l["highRpm"]) {
      _content += `<div class="mapwindow-text">` + this.dic.l["rpm1"] + `: <b>` + this.numberWithCommas(parseInt(this.addinfo)) + `</b> rpm</div>`
    }
    if (this.driverscore == 'true' && this.scoredesc == this.dic.l["longIdling"]) {
      _content += `<div class="mapwindow-text">` + this.dic.l["idletime"] + `: <b>` + this.sec2str3(parseInt(this.addinfo)) + `</b></div>`
    }

    if (this.location != '') {
      _content += `<div class="mapwindow-text" style="max-width:200px">` + this.dic.l["Location"] + `: <b>` + this.location + `</b></div>`
    }
    var infowindow = new google.maps.InfoWindow({
      content: _content
    });
    infowindow.open(this.Map, marker);


  }

}



/*

datetime: "2018-05-30T08:37:06.601Z"

latitude: "41.860331"

longitude: "20.927794"

speed: "120.240000"

vehicleid: 2962

*/


// WEBPACK FOOTER //
// ./src/pages/reports/repmap/repmap.ts